import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    NgZone,
    OnDestroy,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { IFicScreenConfig } from './fic-screen';
import { FicScreenConfig } from './fic-screen-injecotors';
import { Subject } from 'rxjs';

@Component({
    selector: 'fic-screen-portal',
    template: ` <ng-container *ngComponentOutlet="config.componentType"></ng-container> `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fic-screen-portal.component.scss'],
    standalone: false,
})
export class FicScreenPortalComponent implements AfterViewInit, OnDestroy {
    constructor(
        protected renderer: Renderer2,
        protected elementRef: ElementRef<HTMLElement>,
        protected ngZone: NgZone,
        @Inject(FicScreenConfig) public config: IFicScreenConfig<any, any>,
    ) {}

    ngAfterViewInit(): void {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                this.renderer.addClass(this.elementRef.nativeElement, 'fic-screen-show');
            });
        });
    }

    close() {
        return new Promise<void>((resolve) => {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.renderer.removeClass(this.elementRef.nativeElement, 'fic-screen-show');
                });
            });

            setTimeout(() => resolve(), 350);
        });
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
